<script lang="ts">
	import { formatDate } from '$lib/utils';

	import type { MappedPost } from '$lib/utils';

	export let post: MappedPost;
	export let headerTag = 'h2';
	export let queryID = '';
</script>

<article class={post.featuredMedia?.src ? '' : 'no-image'} data-id={post.id}>
	<a href="/cikk/{post.slug}{queryID ? '?qid=' + queryID : ''}" data-sveltekit-preload-data>
		{#if post.featuredMedia?.src}
			<header style="--src: url({post.featuredMedia.src})">
				<img
					src={post.featuredMedia.src}
					srcset={post.featuredMedia.srcset}
					alt={post.featuredMedia.alt}
					width={post.featuredMedia.width}
					height={post.featuredMedia.height}
				/>
			</header>
		{/if}

		<div>
			{#if post.date_gmt}
				<time datetime="{post.date_gmt}Z">{formatDate(post.date)}</time>
			{/if}
			<svelte:element this={headerTag}>{@html post.title.rendered}</svelte:element>
			<p>{@html post.excerpt.rendered}</p>
		</div>
	</a>
</article>

<style lang="postcss">
	p,
	h2,
	h3 {
		transition: opacity .2s var(--ease-in-1);
	}
	article a {
		text-decoration: none;
		color: var(--text-2);
		
		display: block;
		
		
		&:hover :where(p, h2, h3) {
			opacity: 0.9;
		}

		& img {
			/* smash into whatever box it's in */
			inline-size: 100%;
			block-size: 100%;
			max-block-size: 50vh;

			/* don't squish but do cover the space */
			object-fit: cover;

			/* soften the edges */
			overflow: hidden;

			/* if empty, show a gradient placeholder */
			background-image: linear-gradient(to bottom, hsl(0 0% 40%), hsl(0 0% 20%));
			pointer-events: none;
			border-radius: 0.3em;
			height: 300px;
		}
		& header {
			position: relative;
			&::after {
				content: '';
				position: absolute;
				inset: 0;
				opacity: 0;
				will-change: opacity;
				transition: all 0.2s var(--ease-in-1);
				background-repeat: no-repeat;
				background-size: cover;
				background-position: center center;
				background-image: var(--src);
				filter: blur(15px);
				z-index: -1;
			}
		}

		&:hover header::after {
			opacity: 1;
		}

		& p {
			margin-block-end: 0;
			max-inline-size: 100%;
		}

		& :global(h2),
		& :global(h3) {
			display: inline;
			font-size: 2em;
		}

		& div {
			overflow: hidden;
			text-overflow: ellipsis;
			margin-block-start: 0.25em;
		}
	}
	time {
		display: block;
	}

	article:first-child a img {
		height: 500px;
	}
</style>
